module.exports = __webpack_public_path__ + "img/contact_icon_left_menu.10e832a8.svg";